import React, { useEffect } from 'react';
import cn from 'classnames';
import BondType, { INVENTORIES, BWICS } from '@/finsight/domain/BondType';
import BwicCountLabel from '@/finsight/ui/components/bonds/common/BondTables/Bwic/BwicCountLabelContainer';
import InventoryCountLabel from '@/finsight/ui/components/bonds/common/BondTables/Inventory/InventoryCountLabelContainer';
import tabsStyles from '@dealroadshow/uikit/core/styles/tabs.scss';
import styles from './bondTypes.scss';

interface IProps {
  activeTab: string,
  setActiveTab: (tab: string) => void,
  isInventoryEmpty: boolean,
  isBwicEmpty: boolean,
}

const BondTypes = ({ activeTab, setActiveTab, isInventoryEmpty, isBwicEmpty }: IProps) => {
  useEffect(() => {
    if (isInventoryEmpty && !isBwicEmpty) {
      setActiveTab(BWICS);
    }
  }, [isInventoryEmpty]);

  const bwicClassNames = cn(tabsStyles.tab, {
    [tabsStyles.isTabActive]: BondType.isBwics(activeTab),
    [tabsStyles.isTabDisabled]: isBwicEmpty,
  }, styles.buttonsTypes);
  const inventoryClassNames = cn(tabsStyles.tab, {
    [tabsStyles.isTabActive]: BondType.isInventories(activeTab),
    [tabsStyles.isTabDisabled]: isInventoryEmpty,
  }, styles.buttonsTypes);

  return (
    <div className={ styles.typesContainer }>
      <button
        type="button"
        className={ bwicClassNames }
        onClick={ () => setActiveTab(BWICS) }
        disabled={ isBwicEmpty }
        data-test="bondTypeActiveBwicsButton"
      >
        <span>BWICS</span>
        <BwicCountLabel className={ tabsStyles.tabCountLabel } />
      </button>
      <button
        type="button"
        className={ inventoryClassNames }
        onClick={ () => setActiveTab(INVENTORIES) }
        disabled={ isInventoryEmpty }
        data-test="bondTypeActiveInventoriesButton"
      >
        <span>Inventory</span>
        <InventoryCountLabel className={ tabsStyles.tabCountLabel } />
      </button>
    </div>
  );
};

export default BondTypes;
